/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  initialDataLoading: true,
  isFetching: false,
  task: {},
  tasks: [],
  workPackagedTasks: {},
  taskTypes: [],
  isSending: false
};

const groupTasks = (newTasks) => {
  const newCurrentTasks = {};

  newTasks.forEach((task) => {
    const tasks = newCurrentTasks[task.work_package_id] || [];

    newCurrentTasks[task.work_package_id] = tasks.concat(task);
  });

  return newCurrentTasks;
};

const updateWorkPackageTasks = (workPackagedTasks, newTasks) => {
  const newWorkPackageTasks = { ...workPackagedTasks };

  newTasks.forEach((task) => {
    const tasks = newWorkPackageTasks[task.work_package_id] || [];
    const updatedTasks = tasks.map((t) => {
      if (t.id === task.id) {
        return task;
      }
      return t;
    });
    newWorkPackageTasks[task.work_package_id] = updatedTasks;
  });

  return newWorkPackageTasks;
};

const removeWorkPackagedTask = (currentTasks, task) => {
  const newCurrentTasks = { ...currentTasks };

  newCurrentTasks[task.work_package_id] = currentTasks[
    task.work_package_id
  ].filter((item) => item.id !== task.id);

  return newCurrentTasks;
};

const removeFromAllTasks = (tasks, task) =>
  tasks.filter((item) => item.id !== task.id);

const receiveTask = (state, tasks, task) => {
  let newTasks;

  const taskIndex = tasks.findIndex((item) => item.id === task.id);
  if (taskIndex > -1) {
    newTasks = tasks.map((item) => {
      if (item.id === task.id) {
        return task;
      }
      return item;
    });
  } else {
    newTasks = tasks.concat(task);
  }

  return {
    ...state,
    task,
    tasks: newTasks,
    workPackagedTasks: groupTasks(newTasks),
    isFetching: false,
    initialDataLoading: false,
    isSending: false
  };
};

const updateTasks = (tasks, newTasks) => {
  const updatedTasks = tasks.map((t) => {
    const task = newTasks.find((n) => n.id === t.id);
    if (task) {
      return task;
    }
    return t;
  });
  return updatedTasks;
};

const taskReducer = (state = initialState, action) => {
  const { workPackagedTasks, tasks: allTasks } = state;
  const task = action.task && action.task.hidden ? {} : action.task;
  const tasks = action.tasks ? action.tasks.filter((t) => !t.hidden) : [];
  const taskToDelete = allTasks.find((t) => t.id === action.taskId);
  const taskTypes = action.taskTypes ? action.taskTypes : [];

  switch (action.type) {
    case Types.REQUEST_TASK:
      return { ...state, isFetching: true };
    case Types.REQUEST_TASK_FAILED:
      return { ...state, isFetching: false, isSending: false };
    case Types.RECEIVE_TASK:
      return receiveTask(state, allTasks, task);
    case Types.RECEIVE_TASKS:
    case Types.RECEIVE_ALL_TASKS:
      return {
        ...state,
        workPackagedTasks: groupTasks(tasks),
        isFetching: false,
        isSending: false,
        initialDataLoading: false,
        tasks
      };
    case Types.ADD_TASK_TYPE_TO_TASKS:
      return { ...state, taskTypes };
    case Types.RECEIVE_WORK_PACKAGE_TASKS:
      return {
        ...state,
        workPackagedTasks: updateWorkPackageTasks(workPackagedTasks, tasks),
        isFetching: false,
        isSending: false,
        initialDataLoading: false,
        tasks: updateTasks(allTasks, tasks)
      };
    case Types.SEND_TASK:
      return { ...state, isSending: true };
    case Types.CANCEL_SEND_TASK:
      return { ...state, isSending: false };
    case Types.UPDATE_TASK_LIST:
      return {
        ...state,
        workPackagedTasks: groupTasks(tasks),
        isFetching: false,
        isSending: false,
        tasks
      };
    case Types.DELETE_TASK:
      return {
        ...state,
        tasks: removeFromAllTasks(allTasks, task),
        workPackagedTasks: removeWorkPackagedTask(workPackagedTasks, task),
        isFetching: false,
        isSending: false
      };
    case Types.DELETE_TASK_WITH_ID:
      return {
        ...state,
        tasks: removeFromAllTasks(allTasks, taskToDelete),
        workPackagedTasks: removeWorkPackagedTask(
          workPackagedTasks,
          taskToDelete
        ),
        isFetching: false,
        isSending: false
      };
    case Types.TASKS_INITIAL_STATE:
      return { ...initialState };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, isSending: false, initialDataLoading: false }
    default:
      return state;
  }
};

export default taskReducer;
